var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24C13.916 24 11 21.084 11 17.5C11 13.916 13.916 11 17.5 11C21.084 11 24 13.916 24 17.5C24 21.084 21.084 24 17.5 24ZM17.5 12.5C14.743 12.5 12.5 14.743 12.5 17.5C12.5 20.257 14.743 22.5 17.5 22.5C20.257 22.5 22.5 20.257 22.5 17.5C22.5 14.743 20.257 12.5 17.5 12.5Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21C17.086 21 16.75 20.664 16.75 20.25V14.75C16.75 14.336 17.086 14 17.5 14C17.914 14 18.25 14.336 18.25 14.75V20.25C18.25 20.664 17.914 21 17.5 21Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18.25H14.75C14.336 18.25 14 17.914 14 17.5C14 17.086 14.336 16.75 14.75 16.75H20.25C20.664 16.75 21 17.086 21 17.5C21 17.914 20.664 18.25 20.25 18.25Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19 21H2.75C1.233 21 0 19.767 0 18.25V2.75C0 1.233 1.233 0 2.75 0H14.25C15.767 0 17 1.233 17 2.75V8.84C17 9.254 16.664 9.59 16.25 9.59C15.836 9.59 15.5 9.254 15.5 8.84V2.75C15.5 2.061 14.939 1.5 14.25 1.5H2.75C2.061 1.5 1.5 2.061 1.5 2.75V18.25C1.5 18.939 2.061 19.5 2.75 19.5H9.19C9.604 19.5 9.94 19.836 9.94 20.25C9.94 20.664 9.604 21 9.19 21Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 9.5H3.75C3.336 9.5 3 9.164 3 8.75C3 8.336 3.336 8 3.75 8H13.25C13.664 8 14 8.336 14 8.75C14 9.164 13.664 9.5 13.25 9.5Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13.5H3.75C3.336 13.5 3 13.164 3 12.75C3 12.336 3.336 12 3.75 12H9.25C9.664 12 10 12.336 10 12.75C10 13.164 9.664 13.5 9.25 13.5Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.5H3.75C3.336 5.5 3 5.164 3 4.75C3 4.336 3.336 4 3.75 4H8.25C8.664 4 9 4.336 9 4.75C9 5.164 8.664 5.5 8.25 5.5Z",
    fill: "#25368D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.30be252db4a445abd6485e0190fdd77a.svg";
export { ForwardRef as ReactComponent };